import { render, staticRenderFns } from "./Inventaire.vue?vue&type=template&id=e60f4c44&scoped=true&"
import script from "./Inventaire.vue?vue&type=script&lang=ts&"
export * from "./Inventaire.vue?vue&type=script&lang=ts&"
import style0 from "./Inventaire.vue?vue&type=style&index=0&id=e60f4c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60f4c44",
  null
  
)

export default component.exports